import { render, staticRenderFns } from "./User-File-Drop-Down.vue?vue&type=template&id=f2bf5e4c&"
import script from "./User-File-Drop-Down.vue?vue&type=script&lang=js&"
export * from "./User-File-Drop-Down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports